import { Component, Input, ViewEncapsulation, OnDestroy } from '@angular/core';
import { IdService } from '../../shared/services/id.service';
import { TBadgePositionX } from './badge.types';

@Component({
	selector: 'rbc-badge',
	templateUrl: './badge.component.html',
	styleUrls: ['./badge.component.scss'],
	encapsulation: ViewEncapsulation.None
})
export class BadgeComponent implements OnDestroy {
	@Input() id: string;
	@Input() labelSr: string;
	@Input() message: string | number = 0;
	@Input() positionX: TBadgePositionX = 'right';

	constructor(private idService: IdService) {
		this.id = this.idService.generate();
	}

	ngOnDestroy(): void {
		if (this.idService) {
			this.idService.remove(this.id);
		}
	}
}
